import type { Ref, RefObject, MutableRefObject } from 'react';
import { nonNullable } from 'app/src/nonNullable';

/*
 * mergeRefs accepts refs to merge and returns a single callback
 * ref that will properly set each ref passed, whether that ref
 * is a function or a ref object.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeRefs = <T = any>(
  ...refs: Array<Ref<T> | RefObject<T> | undefined>
) => {
  const filteredRefs = refs.filter(nonNullable);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 1) return filteredRefs[0];
  return (refInstance: T) => {
    for (const ref of filteredRefs) {
      if (typeof ref === 'function') {
        ref(refInstance);
      } else if (ref) {
        (ref as MutableRefObject<T | null>).current = refInstance;
      }
    }
  };
};
